/* eslint-disable no-console */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Button, Icon, Modal, ModalFooter } from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';
import { CalloutContext, useOkapiKy } from '@folio/stripes-core';

const propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  templateId: PropTypes.object,
  goBack: PropTypes.func,
};

function DeleteTemplateModal({ onClose, open, templateId, goBack }) {
  const okapiKy = useOkapiKy();
  const context = useContext(CalloutContext);

  const onDelete = () => {
    okapiKy
      .delete(`inventory-templates/${templateId}`, {
        timeout: 30000,
        method: 'DELETE',
        headers: {
          'content-Type': 'application/json',
          accept: 'text/plain',
        },
      })
      .json()
      .then(() => {
        const message = (
          <FormattedMessage
            id="ui-plugin-inventory-templates.deleteTemplateModal.callout.deleted"
            defaultMessage="template deleted successfully"
          />
        );
        context.sendCallout({ message, type: 'success' });
        onClose();
        goBack();
      })
      .catch(async (err) => {
        console.log(err);
        const res = err.response;
        const text = await res.text();
        console.log(text);
        context.sendCallout({ message: text, type: 'error' });
      });
  };

  const renderFooter = () => {
    return (
      <ModalFooter>
        <Button
          id="delete-template-modal-delete-btn"
          buttonStyle="primary"
          onClick={() => onDelete()}
        >
          <FormattedMessage
            id="ui-plugin-inventory-templates.deleteTemplateModal.buttons.delete"
            defaultMessage="Delete"
          />
        </Button>
        <Button
          id="delete-template-modal-cancel-btn"
          onClick={onClose}
        >
          <FormattedMessage
            id="ui-plugin-inventory-templates.buttons.cancel"
            defaultMessage="Cancel"
          />
        </Button>
      </ModalFooter>
    );
  };

  return (
    <Modal
      id="delete-template-modal"
      open={open}
      onClose={onClose}
      footer={renderFooter()}
      label={
        <Icon icon="trash" size="large">
          <FormattedMessage
            id="ui-plugin-inventory-templates.deleteTemplateModal.label"
            defaultMessage="Delete Template"
          />
        </Icon>
      }
      dismissible
    >
      <strong>
        <FormattedMessage
          id="ui-plugin-inventory-templates.deleteTemplateModal"
          defaultMessage="Are you sure to delete the template?"
        />
      </strong>
    </Modal>
  );
}

DeleteTemplateModal.propTypes = propTypes;
export default DeleteTemplateModal;
